import {
  GET_MEDIA_GALLERY_SUCCESS,
  GET_MEDIA_GALLERY_USERS_SUCCESS,
  GET_MEDIA_GALLERY_DESIGN_SUCCESS,
  RESET_MEDIA_GALLERY,
  GET_LANDING_GALLERY_SUCCESS,
  GET_MEDIA_GALLERY_LIST_SUCCESS,
  RESET_MEDIA_GALLERY_LIST,
  UPLOAD_EVENT_MEDIA_SUCCESS,
  UPLOAD_LANDING_MEDIA_SUCCESS,
  DELETE_MEDIA_GALLERY_ITEM_SUCCESS,
  DELETE_LANDING_MEDIA_SUCCESS,
  GET_FLAGGED_MEDIA_SUCCESS,
  RESET_FLAGGED_MEDIA,
  DELETE_MEDIA_REPORT_SUCCESS,
  GET_MEDIA_GALLERY_DESIGN,
  GET_MEDIA_GALLERY_DESIGN_FAILED,
  DELETE_MEDIA_GALLERY_ITEM,
  DELETE_MEDIA_GALLERY_ITEM_FAILED,
  DELETE_LANDING_MEDIA,
  DELETE_LANDING_MEDIA_FAILED,
} from "./actionTypes"

const INIT_STATE = {
  mediaGalleryDesign: null,
  mediaGallery: [],
  mediaGalleryUsers: null,
  mediaGalleryList: null,
  flaggedMedia: [],
  loading: false,
  deleteLoading: false,
}

const MediaGallery = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPLOAD_EVENT_MEDIA_SUCCESS:
    case UPLOAD_LANDING_MEDIA_SUCCESS:
    case GET_MEDIA_GALLERY_SUCCESS:
    case GET_LANDING_GALLERY_SUCCESS:
      return {
        ...state,
        mediaGallery: action.payload,
      }
    case GET_MEDIA_GALLERY_USERS_SUCCESS:
      return {
        ...state,
        mediaGalleryUsers: action.payload,
      }
    case GET_MEDIA_GALLERY_DESIGN:
      return {
        ...state,
        loading: true,
      }
    case GET_MEDIA_GALLERY_DESIGN_SUCCESS:
      return {
        ...state,
        mediaGalleryDesign: action.payload,
        loading: false,
      }
    case GET_MEDIA_GALLERY_DESIGN_FAILED:
      return {
        ...state,
        loading: false,
      }
    case DELETE_MEDIA_GALLERY_ITEM:
    case DELETE_LANDING_MEDIA:
      return {
        ...state,
        deleteLoading: true,
      }
    case DELETE_MEDIA_GALLERY_ITEM_SUCCESS:
      return {
        ...state,
        mediaGallery: state.mediaGallery.filter(
          item => !action.payload.ids.includes(item.id)
        ),
        flaggedMedia: state.flaggedMedia?.filter(
          x => !action.payload.ids.includes(x?.gallery?.id)
        ),
        deleteLoading: false,
      }
    case DELETE_MEDIA_GALLERY_ITEM_FAILED:
    case DELETE_LANDING_MEDIA_FAILED:
      return {
        ...state,
        deleteLoading: false,
      }
    case DELETE_LANDING_MEDIA_SUCCESS:
      return {
        ...state,
        mediaGallery: state.mediaGallery.filter(
          item => !action.payload.ids.includes(item.id)
        ),
        deleteLoading: false,
      }
    case RESET_MEDIA_GALLERY:
      return {
        ...state,
        mediaGallery: [],
        mediaGalleryUsers: null,
        mediaGalleryDesign: null,
      }
    case GET_MEDIA_GALLERY_LIST_SUCCESS:
      return {
        ...state,
        mediaGalleryList: action.payload,
      }
    case RESET_MEDIA_GALLERY_LIST:
      return {
        ...state,
        mediaGalleryList: null,
      }
    case GET_FLAGGED_MEDIA_SUCCESS:
      return {
        ...state,
        flaggedMedia: action.payload,
      }
    case RESET_FLAGGED_MEDIA:
      return {
        ...state,
        flaggedMedia: [],
      }
    case DELETE_MEDIA_REPORT_SUCCESS:
      return {
        ...state,
        flaggedMedia: state?.flaggedMedia?.filter(
          x => x?.id !== action.payload
        ),
      }
    default:
      return state
  }
}

export default MediaGallery
